// extracted by mini-css-extract-plugin
export default {"btn":"BorrowedBooksRow_btn__T7I++","table-number-cell":"BorrowedBooksRow_table-number-cell__3W7BD","tr":"BorrowedBooksRow_tr__dkkYc"};